export function parseBoundedInteger(
  raw: string,
  min: number,
  max: number
): number | null {
  const trimmed = raw.trim();
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }

  const value = Number(trimmed);
  if (!Number.isSafeInteger(value)) {
    return null;
  }
  if (value < min || value > max) {
    return null;
  }

  return value;
}
